export enum EContracts {
  ELECTRONIC_COMMUNICATION = 'electronic_communication',
  LITE_CONTRACT = 'lite_contract',
  PERSONAL_INFORMATION = 'personal_information',
  TARIFF = 'tariff',
}